export const ToastType = {
    ALERT: 'alert',
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',

    LOADING: 'loading'
} as const;